'use es6';

import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import I18n from 'I18n';
import { Small } from 'foundations-components/transitional/components/Small';
import { isEmptySnowflakeProperty } from '../../../../metadata/report-meta';
import { useFilterEdit } from '../FilterEditContext';
import SnowflakeFilterEditPopover from '../SnowflakeFilterEditPopover';
import SnowflakeFilterWrapper from '../SnowflakeFilterWrapper';
import { useProperty, useTableSource } from '../SourceMeta';
import DeletedPropertyFilterLabel from './DeletedPropertyFilterLabel';
import PropertyFilterLabel from './PropertyFilterLabel';
import { NewPropertyFilterPanel } from './NewPropertyFilterPanel';
import PropertyFilterPanelBase from './PropertyFilterPanel';
import { useFilterRelevantUserInfo } from '../../../../../shared/lib/utils';
import { getIsUngatedToSnowflakePropertyFilterMigration } from '../../../../utils/filter-utils';
import PropertyFilterDisplayLabel from './PropertyFilterDisplayLabel';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertyFilterPanel = _ref => {
  let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  const [__, {
    handleFilterChange,
    handleCancelEdit,
    handleCloneFilterToGroup
  }] = useFilterEdit();
  const {
    userGates
  } = useFilterRelevantUserInfo();
  if (!userGates || !userGates.length) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  const isUngatedToSnowflakePropertyFilters = getIsUngatedToSnowflakePropertyFilterMigration(userGates);
  const FilterPanel = isUngatedToSnowflakePropertyFilters ? NewPropertyFilterPanel : PropertyFilterPanelBase;
  return /*#__PURE__*/_jsx(FilterPanel, Object.assign({}, props, {
    onDone: ({
      draftFilter,
      draftGroupId
    }) => handleFilterChange(draftFilter, draftGroupId),
    onCloneFilter: ({
      draftFilter,
      groupId
    }) => handleCloneFilterToGroup(draftFilter, groupId),
    onCancel: handleCancelEdit
  }));
};
const PropertyFilterItem = ({
  filter,
  groupIndex,
  filterIndex,
  readOnly
}) => {
  const {
    field: {
      table,
      name: fieldName
    }
  } = filter;
  const [{
    editingGroupIndex,
    editingFilterIndex
  } = {}, editCallbacks] = useFilterEdit();
  const showEditPanel = groupIndex === editingGroupIndex && filterIndex === editingFilterIndex;
  const {
    userGates
  } = useFilterRelevantUserInfo();
  const missingSource = useTableSource(table) == null;
  const property = useProperty(table, fieldName);
  if (!userGates || !userGates.length) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  const isUngatedToSnowflakePropertyFilters = getIsUngatedToSnowflakePropertyFilterMigration(userGates);
  const missingProperty = property == null;
  if (missingSource || missingProperty || isEmptySnowflakeProperty(property)) {
    return /*#__PURE__*/_jsxs(SnowflakeFilterWrapper, {
      highlighted: false,
      onRemove: () => editCallbacks.handleFilterRemove(groupIndex, filterIndex),
      readOnly: readOnly,
      children: [/*#__PURE__*/_jsx(DeletedPropertyFilterLabel, {
        filter: filter
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: I18n.text('reporting-snowflake.metadata-errors.invalid-property')
      })]
    });
  }
  const editPanel = /*#__PURE__*/_jsx(PropertyFilterPanel, {
    filter: filter,
    groupId: groupIndex
  });
  return /*#__PURE__*/_jsx(SnowflakeFilterEditPopover, {
    editPanel: editPanel,
    open: showEditPanel,
    onClose: editCallbacks.handleCancelEdit,
    disabled: readOnly,
    children: /*#__PURE__*/_jsx(SnowflakeFilterWrapper, {
      highlighted: showEditPanel,
      onEdit: () => editCallbacks.handleFilterEdit(groupIndex, filterIndex),
      onRemove: () => editCallbacks.handleFilterRemove(groupIndex, filterIndex),
      readOnly: readOnly,
      children: isUngatedToSnowflakePropertyFilters ? /*#__PURE__*/_jsx(PropertyFilterDisplayLabel, {
        filter: filter
      }) : /*#__PURE__*/_jsx(PropertyFilterLabel, {
        filter: filter
      })
    })
  });
};
export default PropertyFilterItem;